import { memo } from 'react';
import { useVisible } from '@wappsto/blanket';
import LoginButton from './components/LoginButton';
import AuthenticationModal from './components/AuthenticationModal';

interface AuthenticationProps {
  buttonStyle?: Record<string, any>;
}

const Authentication = memo(({ buttonStyle = {} }: AuthenticationProps) => {
  const [visible, show, hide] = useVisible(false);

  return (
    <>
      <LoginButton onClick={show} style={buttonStyle} />
      <AuthenticationModal hide={hide} isVisible={visible} />
    </>
  );
});

Authentication.displayName = 'Authentication';

export default Authentication;
